export default __webpack_public_path__ + "static/media/email-icon.fb3ae342.svg";